import api from '@/sui/api/api'

import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    all (request) {
      const uri = 'incidences/' + request.inf
      return api.post(uri, request)
    },

    compute (request) {
      const uri = 'incidences/compute'
      return api.post(uri, request)
    },

    freeze (request) {
      return api.post('incidences/freeze', request)
    }
  }
} else {
  module = {

    all (request) {
      return delay(1500)({
        data: {
          err: 'Erreur au chargement des fiches.'
        }
      })
    }
  }
}

export default module
